// Cabecera con la sesion de Firebase del panel. El servidor del panel la exige para enviar
// WhatsApp y para administrar las lineas: sin ella cualquiera que conozca la URL podria
// mandar mensajes desde los numeros de la empresa.
import { auth } from '../firebaseConfig';

export const cabeceraSesion = async () => {
  try {
    const usuario = auth.currentUser;
    if (!usuario) return {};
    const token = await usuario.getIdToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch (error) {
    console.error('No se pudo obtener la sesion del panel:', error);
    return {};
  }
};

// POST JSON con la sesion del panel.
export const postJsonConSesion = async (url, params) => fetch(url, {
  method: 'POST',
  headers: { 'content-type': 'application/json', ...(await cabeceraSesion()) },
  body: JSON.stringify(params)
});
